<style>
  .clearfix:after {
    content: '';
    display: block;
    visibility: hidden;
    clear: both;
  }
  .select-container {
    padding: 15px 2% 3px;
  }
  .select-left {
    float: left;
    display: table;
  }
  .select-left > div {
    vertical-align: top;
  }
  .select-left > div:not(:last-child) {
    margin-right: 5px;
  }
  .select-right {
    float: right;
  }
</style>

<template>
  <div>
    <div class="select-container clearfix" style="margin-top: 2%;margin-left: 2%;float: left;">
    <span style="font-size:30px;font-weight:bold;">DLP安装指南 for mac</span><br><br>
    <span style="font-size:30px;font-weight:bold;color:red">MAC终端包安装完成后会重启操作系统，请勿在安装过程中升级操作系统~</span><br><br>
    <p>软件下载地址：<a style="color:#1890ff" title="https://itportal.sankuai.com/" href="https://itportal.sankuai.com/" class="ct-link" rel="noopener" target="_blank">https://itportal.sankuai.com/</a></p>
    <img src="../assets/dataLeakInstallForMac/dataLeakInstallForMac_pic14.png" width=850px height=200px ><br>
    <img src="../assets/dataLeakInstallForMac/dataLeakInstallForMac_pic15.png" width=850px height=330px ><br>
    &nbsp;&nbsp;一、软件安装<br>
    &nbsp;&nbsp;二、绑定用户名<br><br>
    <span style="font-size:20px;color:red">一、软件安装</span><br>
    解压文件， 双击安装包MTDLP.pkg，若弹出一下窗口：<br>
    <img src="../assets/dataLeakInstallForMac/dataLeakInstallForMac_pic1.png" width=500px height=230px ><br>
    则打开 “系统偏好设置” -“安全性与隐私”，选择“通用”，点击 “仍要打开”。<br>
    <img src="../assets/dataLeakInstallForMac/dataLeakInstallForMac_pic2.png" width=500px height=450px ><br>
    再次双击安装包MTDLP.pkg，弹出框图填写mis账号（外包职场用户在本步骤中请填写meituan）<br>
    <img src="../assets/dataLeakInstallForMac/dataLeakInstallForMac_pic3.png" width=380px height=150px ><br>
    1. 点击“继续”<br>
    <img src="../assets/dataLeakInstallForMac/dataLeakInstallForMac_pic4.png" width=550px height=400px ><br>
    2. 点击“继续”，并同意协议条款<br>
    <img src="../assets/dataLeakInstallForMac/dataLeakInstallForMac_pic5.png" width=550px height=400px ><br>
    <img src="../assets/dataLeakInstallForMac/dataLeakInstallForMac_pic6.png" width=550px height=400px ><br>
    3. 点击“继续”<br>
    <img src="../assets/dataLeakInstallForMac/dataLeakInstallForMac_pic7.png" width=550px height=400px ><br>
    <img src="../assets/dataLeakInstallForMac/dataLeakInstallForMac_pic8.png" width=550px height=400px ><br>
    此处密码使用<span style="color:red">登录电脑系统的密码</span>。<br>
    <img src="../assets/dataLeakInstallForMac/dataLeakInstallForMac_pic9.png" width=550px height=400px ><br>
    <img src="../assets/dataLeakInstallForMac/dataLeakInstallForMac_pic10.png" width=550px height=400px ><br>
    <span style="font-size:20px;color:red">二、绑定账号</span><br><br>
    安装完成后 会跳出如下界面<br><br>
    <span style="font-size:30px;color:red">注意 ：<br>
   （1）账号为mis账号，请填写正确的mis账号；<br>
   （2）如使用自己的mis帐号提示用户名不存在，请输入meituan。<br>
    如：用户名：meituan </span><br>
    <img src="../assets/dataLeakInstallForMac/dataLeakInstallForMac_pic11.png" width=550px height=400px ><br><br>
    <span style="font-size:15px;color:red">输入用户名，点击确认后，窗口会自动缩小，代表已经绑定成功了。</span><br><br>
    <span style="font-size:25px;color:red">安装过程中，程序会自动识别您的mis账号，若无法识别，程序会打开一个浏览器，并打开一个如下的注册页面，请务必真实填写您的真实信息！！<br>
    如果未出现弹窗说明被系统识别mis账号，忽略此步骤（已安装却仍收到SSO消息提醒 ，解决方法详见
    <span style="color:#63B8FF;text-decoration:underline;cursor:pointer" @click="kmUrl('https://km.sankuai.com/page/19884626')">已安装却仍收到SSO消息提醒</span>）</span><br>
    <img src="../assets/dataLeakInstallForMac/dataLeakInstallForMac_pic12.png" width=550px height=400px ><br>
    <span style="font-size:25px;color:green">MAC版本安装过程TIPS：<br>
    mac终端安装过程中出现如下内容乱码情况</span><br>
    <img src="../assets/dataLeakInstallForMac/dataLeakInstallForMac_pic13.png" width=600px height=450px ><br>
    解决方法：是因为mac系统语言使用的是英文，出现内容乱码，直接continue即可（不影响后续使用）。<br><br>
    <span style="color:red">由于评论较多，可能不能及时回复，有问题可以直接大象6000或者私聊huawei02。</span>
    <br>
    <br>
    </div>
  </div>
</template>

<script>
  import store from '../vuex/service/store'
  import axios from 'axios'
  import {mapState} from 'vuex';
  import util from '../views/util/commonUtil'

  export default {
    store: store,
    mounted: function () {
      var vm =this;
      if(vm.token == ""){
        var token = this.getCookie("access-token");
        if(token != null){
          vm.$store.commit('UPDATETOKEN',token);
          vm.token = token;
        }
      }
      vm.getUser();
    },
    computed: mapState({
      loginRediret: function (state) {
        return state.loginRediret;
      },
      cookieName: function (state) {
        return state.cookieName;
      },
      getuserAPI: function (state) {
        return state.getuserAPI;
      }
    }),
    filters: {
      idcExplain(val) {
        return util.idcExplain(val)
      },
      timeFormat(val) {
        return util.timeFormat(val)
      },
      switchColor(val) {
        return util.switchColor(val)
      },
      statusExplain(val) {
        return util.statusExplain(val)
      }
    },
    methods: {
      reset() {
        var vm = this;
        vm.name = '';
        vm.rasp = '';
        vm.proc = '';
        vm.ws = '';
        vm.query_arg = 'hostname';
        vm.query_value = '';
      },
      masterStatusColor(status) {
        if (status == 1) {
          return "#A1D6E4"
        }
        if (status == 0) {
          return "#878D99"
        }
        if (status == 4) {
          return "#878D99"
        }
        if (status == 6) {
          return "#F5A9A9"
        }
        if (status == 5) {
          return "#FFC78E"
        }
      },
      kmUrl(URL){
        window.open(URL);
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      getCookie(name){
        var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
        if(arr=document.cookie.match(reg))
          return unescape(arr[2]);
        else
          return null;
      },
      getUser() {
        var vm = this;
        if (vm.user == null || vm.user == "") {
          vm.user = vm.getCookie("username");
          document.cookie="ssoid="+vm.getCookie("access-token");
          axios.get(vm.getuserAPI, {
            withCredentials: true
          }).then((response) => {
            if(response.data.status==401){
               document.cookie = vm.cookieName + vm.$route.fullPath;
               window.location = vm.loginRediret;
            }

          }).catch(function (error) {
            vm.requesterrorinfo(error)
          })
        }
      },
      requesterrorinfo(error){
        var vm =this;
        if (error.response) {
          var code = error.response.status;
          if (code == 401) {
            vm.$message.error("401:您未登录");
            var count = vm.getCookie("access-count")
            window.location = vm.loginRediret;
            if(count==null || count==0){
              document.cookie="access-count=1";
              vm.$message('您未登录,请刷新');
              document.cookie = vm.cookieName + vm.$route.fullPath;
              window.location = vm.loginRediret;
            }else{
              vm.$message('您未登录,请刷新');
            }
          } else {
            if (code == 404) {
              vm.$notify({
                title: '提示',
                message: '404:Not found!',
                type: 'error'
              });
            } else {
              vm.$notify({
                title: '提示',
                message: '501:服务端未响应!',
                type: 'error'
              });
            }
          }
        } else {
          vm.$notify({
            title: '提示',
            message: '502:服务端未响应!',
            type: 'error'

          });
        }
      }
    },
    data() {
      return {
        hostname:'',
        token:''
      }
    }
  }
</script>
<style>
  .select1 {
    width: 100px;
  }
  .select2 {
    width: 130px;
  }
  .select3 {
    width: 160px;
  }
  .input1 {
    width: 350px;
  }
  .input2 {
    width: 210px;
  }
  .demo-table-expand label {
    width: 140px;
    color: #5d94bf;
  }
</style>



// WEBPACK FOOTER //
// dataLeakInstallForMac.vue?cf47cd3e